onReady(() => {
    const siteNoticeBar = Array.from(document.querySelectorAll('.site-notice-bar'))
    for (const siteNotice of siteNoticeBar) {
        // This is spoofed as it is not technically a module
        const moduleElement = {
            dataset: {
                moduleName: 'Site Notice Bar',
                modulePosition: 0,
                distinctModulePosition: 0,
                moduleTabPosition: 0,
                moduleId: 'site-notice-bar',
            }
        };
        const ctaButton = siteNotice.querySelector('a');
        ctaButton.addEventListener('click', (event) => submitCtaClickEvent(event, siteNotice, moduleElement));
    }
})
